import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="bg-ink px-5 py-10 text-white lg:px-8" aria-label="El sistema en números" data-id="element-226" data-mp="1tarjq9bipqkw">
      <dl className="mx-auto grid max-w-6xl gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-227" data-mp="1ob57a23iked5">
        {stats.map(stat => <div key={stat.label} data-id="element-228" data-mp="1jcu05z4lshym">
            <dt className="sr-only" data-id="element-229" data-mp="1jbsktigk19b3">{stat.label}</dt>
            <dd data-id="element-230" data-mp="1ecz8vugx1qd1">
              <span className="display block text-3xl text-grass sm:text-4xl" data-id="element-231" data-mp="1edh9126p8oq8">
                {stat.value}
              </span>
              <span className="mt-2 block text-sm leading-relaxed text-white/65" data-id="element-232" data-mp="19ky0ijmvcjsa">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}